import { useEffect, useReducer, useState } from "react";
import { toast } from "react-toastify";
import { LoadingStatus } from "../enums/loadingStatus";

export function useLoadHandler(
  fetchAsync: (e: any) => Promise<Function | void>
) {
  const [loadingStatus, setLoadingStatus] = useState(LoadingStatus.IDLE);

  async function callFetchAsync(e?: any) {
    await setLoadingStatus?.(LoadingStatus.LOADING);
    try {
      const onFetchSuccess = await fetchAsync?.(e);
      setLoadingStatus?.(LoadingStatus.SUCCESS);
      onFetchSuccess?.();
    } catch (error: any) {
      toast.error(error.message);
      setLoadingStatus?.(LoadingStatus.ERROR);
    }
  }

  return { loadingStatus, callFetchAsync };
}

export function useErrorHandler(
  fetchAsync: (e: any) => Promise<Function | void>
) {
  async function callFetchAsync(e?: any) {
    try {
      const onFetchSuccess = await fetchAsync?.(e);
      onFetchSuccess?.();
    } catch (error: any) {
      toast.error(error.message);
    }
  }

  return { callFetchAsync };
}
